import React, { PureComponent } from 'react';
import { Consumer as AppContextConsumer } from '../../../contexts/AppContext/AppContext';

function withAppContext(Component) {
  class WithAppContext extends PureComponent {
    render() {
      return <AppContextConsumer>{context => <Component {...context} {...this.props} />}</AppContextConsumer>;
    }
  }
  return WithAppContext;
}

export default withAppContext;
